const noop =
  func =>
  (...args) =>
    func(...args);

export default noop;
